import React from 'react';

const LodingAnimation=() => { return( 
    <>
        <div class="loader"></div>
    </>
)}

export default LodingAnimation;